import actions from '../../actionTypes';

export default trigger => {
  return {
    type: actions.EDITED_TRIGGER,
    trigger
  };
};



// WEBPACK FOOTER //
// ./src/reducers/triggers/actions/editedTrigger.js